import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notice } from '@features/dashboard/components/noticeboard/types';

interface NoticeboardState {
  notices: Notice[];
  isLoading: boolean;
  error: string | null;
}

const initialState: NoticeboardState = {
  notices: [],
  isLoading: false,
  error: null
};

export const noticeboardSlice = createSlice({
  name: 'noticeboard',
  initialState,
  reducers: {
    setNotices: (state, action: PayloadAction<Notice[]>) => {
      state.notices = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});

export const { setNotices, setLoading, setError } = noticeboardSlice.actions;

export default noticeboardSlice.reducer;
